import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  template: `
    <div class="app-loading" [hidden]="!isBusy">
      <div fxLayout="column" fxLayoutAlign="center center">
        <div fxFlex="100">
          <mat-spinner [strokeWidth]="5" [diameter]="100"></mat-spinner>
        </div>
      </div>
    </div>
    <div [hidden]="isBusy">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent implements OnInit {
  @Input() isBusy = false;

  constructor() { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() { }
}
